export default __webpack_public_path__ + "static/gabriel-nicolas-f1cdcf2247c0fedd35945f9372cb3b83.jpg";